import React from 'react'
import { Nav, Tab } from 'react-bootstrap'
import { PLANS } from '../../../constants/plans'
import StripePay from './Stripe/StripePay'

import PaddleBillingPay from './PaddleBilling/PaddleBillingPay'

const PaymentTabs = ({
  plan,
  period,
  priceData,
  isLoading,
  isError,
  hasUcc,
  showExtra,
  dispatch,
  email,
  studentData,
  source,
  accountCreated,
  userProfile,
  handleCouponCodeChange,
  errorMessage,
  setErrorMessage,
  extraTeamMembers,
  teamMemberPriceId,
  transactionState,
  activePaymentTab = 'card',
  setActivePaymentTab,
  stripeOnly = false
}) => {
  return (
    <Tab.Container activeKey={activePaymentTab} onSelect={(key) => setActivePaymentTab && setActivePaymentTab(key)}>
      <Nav variant="pills" className={`flex-row tabs ${isLoading || isError ? 'd-none' : ''}`}>
        <Nav.Item>
          <Nav.Link eventKey="card">
            <h2 className="fs-normal">
              <img alt="Credit Card" src="/assets/icons/credit-card.svg" className="me-2 opacity-50" height={20} />
              Card
            </h2>
          </Nav.Link>
        </Nav.Item>

        {!stripeOnly && !hasUcc && (
          <Nav.Item>
            <Nav.Link eventKey="paddle-billing">
              <h2 className="fs-normal">
                <img alt="paddle" src="/assets/icons/paypal.svg" className="me-2 opacity-50" height={18} />
                PayPal
              </h2>
            </Nav.Link>
          </Nav.Item>
        )}
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="card">
          <StripePay
            className={isLoading || isError ? 'd-none' : 'd-block mt-3'}
            dispatch={dispatch}
            priceData={priceData}
            email={email}
            studentData={studentData}
            source={source}
            productId={plan.id}
            period={period}
            accountCreated={accountCreated}
            userProfile={userProfile}
            handleCouponCodeChange={handleCouponCodeChange}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            extraTeamMembers={extraTeamMembers}
            teamMemberPriceId={teamMemberPriceId}
          />
        </Tab.Pane>

        {!stripeOnly && plan.id !== PLANS.API.id && !showExtra && !hasUcc && (
          <Tab.Pane eventKey="paddle-billing" unmountOnExit={false} mountOnEnter={true}>
            <PaddleBillingPay
              className={isLoading || isError ? 'd-none' : 'd-block'}
              dispatch={dispatch}
              email={email}
              studentData={studentData}
              paddleBillingId={priceData.paddle?.priceId}
              transactionState={transactionState}
              source={source}
              productId={plan.id}
              period={period}
              accountCreated={accountCreated}
            />
          </Tab.Pane>
        )}
      </Tab.Content>
    </Tab.Container>
  )
}

export default PaymentTabs
